import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
import * as labsComponents from "vuetify/labs/components";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";
import "vuetify/styles";
import { es, en } from "vuetify/locale";
const myCustomLightTheme = {
  dark: false,
  colors: {
    background: "#BFBFBE",
    surface: "#FFFFFF",
    primary: "#6200EE",
    "primary-darken-1": "#3700B3",
    secondary: "#03DAC6",
    "secondary-darken-1": "#018786",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};
export default createVuetify({
  components: { ...components, ...labsComponents },
  directives,
  locale: {
    locale: "es",
    fallback: "es",
    messages: { es, en },
  },
  theme: {
    defaultTheme: "myCustomLightTheme",
    themes: {
      myCustomLightTheme,
    },
  },
});
